let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gjxqp")).then(() => parcelRequire('bhbO7'));